import { useAppTFunction } from '@retail/app/i18n';
import { GroupOption } from '@retail/products/types';
import { TypographyVariant } from '@mui/material';
import { useMemo } from 'react';
import { ToggleGroup, ToggleGroupOption } from '../ToggleGroup';

export interface GroupOptionToggleProps {
  label: string;
  value: GroupOption;
  onChange: (option: GroupOption) => void;
  allLabel?: string;
  yesLabel?: string;
  noLabel?: string;
  hideAllOption?: boolean;
  labelDirection?: 'horizontal' | 'vertical';
  labelVariant?: TypographyVariant;
  justifyContent?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  description?: string;
  size?: 'small' | 'medium' | 'large';
}

export function GroupOptionToggle({
  label,
  value,
  onChange,
  allLabel,
  yesLabel,
  noLabel,
  hideAllOption = false,
  labelDirection = 'vertical',
  labelVariant,
  justifyContent,
  fullWidth = true,
  disabled,
  description,
  size = 'small',
}: GroupOptionToggleProps) {
  const t = useAppTFunction();

  const options: ToggleGroupOption<GroupOption>[] = useMemo(() => {
    const allOption = {
      label: allLabel ?? t('suppliers.actions.options.all'),
      value: 'UNSPECIFIED' as const,
    };
    const yesNoOptions = [
      { label: yesLabel ?? t('suppliers.actions.options.yes'), value: 'YES' as const },
      { label: noLabel ?? t('suppliers.actions.options.no'), value: 'NO' as const },
    ];
    return hideAllOption ? yesNoOptions : [allOption, ...yesNoOptions];
  }, [allLabel, yesLabel, noLabel, hideAllOption, t]);

  return (
    <ToggleGroup
      variant="pill"
      label={label}
      labelDirection={labelDirection}
      labelVariant={labelVariant}
      justifyContent={justifyContent}
      description={description}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      options={options}
      value={value}
      onChange={onChange}
    />
  );
}
